// DEPENDENCIES
import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import objectPath from "object-path";
// ICONS
import { AiOutlineFileText, AiOutlineBuild, AiOutlineAppstore, AiOutlineContainer, AiOutlineUser, AiOutlineProfile, AiOutlineBell, AiOutlineFolder } from 'react-icons/ai';
import { HiMenuAlt2 } from 'react-icons/hi';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
// COMPONENTS
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
// THEME COMPONENTS
import { AsideMenu } from "./aside-menu/AsideMenu";
import AsideSearch from "./AsideSearch";
import { Brand } from "../brand/Brand";
import { KTUtil } from "./../../../_assets/js/components/util";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_helpers";

export function Aside(props) {
  const { notifications } = props;
  const uiService = useHtmlClassService();
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    if (notifications) {
      setNotificationCount(notifications.filter(x => x.hasOpened === false).length)
    }
  }, [notifications])

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  const tabs = {
    tabId1: "kt_aside_tab_1",
    tabId2: "kt_aside_tab_2",
    tabId3: "kt_aside_tab_3",
    tabId4: "kt_aside_tab_4"
  };

  const [activeTab, setActiveTab] = useState(tabs.tabId2);
  const iconSize = 30;

  useEffect(() => {
      document.body.classList.add("aside-minimize");
      //document.body.classList.remove("aside-secondary-enabled");
     // document.body.classList.add("aside-secondary-disabled");
  }, [])

  const handleTabChange = (id) => {
    setActiveTab(id);
    const asideWorkspace = KTUtil.find(
      document.getElementById("kt_aside"),
      ".aside-secondary .aside-workspace"
    );
    if (asideWorkspace) {
      KTUtil.scrollUpdate(asideWorkspace);
    }
  };

  return (
    <>
      <div
        id="kt_aside"
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
      >
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          <Brand />
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            <ul className="list-unstyled flex-column" role="tablist">

              {/* MENU */}
              <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="MenuItems"
              >
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="metronic-features">Menu</Tooltip>
                  }
                >
                  <a
                    href="#"
                    className={`nav-link btn btn-icon btn-clean btn-lg aside-icon ${activeTab ===
                      tabs.tabId2 && "active"}`}
                    data-toggle="tab"
                    data-target={`#${tabs.tabId2}`}
                    // onClick={() => handleTabChange(tabs.tabId2)}
                    id="kt_aside_toggle"
                    role="tab"
                  >
                    <span className="svg-icon svg-icon-primary svg-icon-2x">
                      <HiMenuAlt2 size={iconSize} />
                    </span>
                  </a>
                </OverlayTrigger>
              </li>

              {/* PROJECT MANAGEMENT */}
              <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Project Management"
              >
                {layoutProps.extrasQuickActionsDisplay && (
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="toggle-quick-actions">Project Management</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className="btn btn-icon btn-clean btn-lg mb-1 aside-icon"
                      id="kt_quick_actions_toggle"
                    >
                      <span className="svg-icon svg-icon-2x">
                        <AiOutlineFolder size={iconSize} />
                      </span>
                    </a>
                  </OverlayTrigger>
                )}
              </li>

              {/* FORMS */}
              {/* <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Quick Actions"
              >
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="toggle-quick-actions">Forms</Tooltip>
                  }
                >
                  <NavLink to="/forms"
                    className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab === tabs.tabId4 && "active"}`}
                    className="btn btn-icon btn-lg mb-1 aside-icon"
                    onClick={() => handleTabChange(tabs.tabId4)}
                  >
                    <AiOutlineContainer size={iconSize} />
                  </NavLink>
                </OverlayTrigger>
              </li> */}

              {/* NOTIFICATIONS */}
              <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Notifications"
              >
                {layoutProps.extrasQuickActionsDisplay && (
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="toggle-quick-panel">Notifications</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className="btn btn-icon btn-clean btn-lg mb-1 aside-icon"
                      id="kt_quick_panel_toggle"
                      data-placement="right"
                      data-container="body"
                      data-boundary="window"
                    // id="kt_quick_user_toggle"
                    >
                      <span className="svg-icon svg-icon-2x">
                        <AiOutlineBell size={iconSize} />
                        {
                          notificationCount > 0 &&
                          <span className="label label-sm label-light-danger label-rounded font-weight-bolder">
                            {notificationCount}
                          </span>
                        }

                      </span>
                    </a>
                  </OverlayTrigger>
                )}
              </li>

              {/* USER */}
              <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="My Account"
              >
                {layoutProps.extrasQuickActionsDisplay && (
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="toggle-quick-actions">My Account</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className="btn btn-icon btn-clean btn-lg mb-1 aside-icon"
                      id="kt_quick_user_toggle"
                    >
                      <span className="svg-icon svg-icon-2x">
                        <AiOutlineUser size={iconSize} />
                      </span>
                    </a>
                  </OverlayTrigger>
                )}
              </li>
            </ul>
          </div>

          {/* ASIDE FOOTER */}
          <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4">

            {/* ASIDE TOGGLE */}
            {/* {layoutProps.asideSecondaryDisplay &&
              layoutProps.asideSelfMinimizeToggle && (
                <>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="toggle-aside">Expand</Tooltip>}
                  >
                    <span
                      className="aside-toggle btn btn-icon btn-primary"
                      id="kt_aside_toggle"
                    >
                      <i className="ki ki-bold-arrow-back icon-sm" />
                      {
                        // <IoChevronForwardOutline size={20} />
                      }
                    </span>
                  </OverlayTrigger>
                </>
              )} */}

            {layoutProps.extrasSearchDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-search">Quick Search</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_search_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}

            {/* {layoutProps.extrasNotificationsDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="toggle-notifications">Notifications</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_notifications_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )} */}
            {/* end::Notifications */}

            {/* begin::Quick Actions */}

            {/* end::Quick Actions */}

            {/* begin::Quick Panel */}
            {/* {layoutProps.extrasQuickPanelDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-quick-panel">Notifications</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_panel_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Layout/Layout-4-blocks.svg"
                      )}
                    />
                  </span>
                  <span className="label label-sm label-light-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                    3
                  </span>
                </a>
              </OverlayTrigger>
            )} */}
            {/* end::Quick Panel */}

            {/* {layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />} */}

            {/* {layoutProps.extrasUserDisplay && <QuickUserToggler />} */}
          </div>
        </div>

        {layoutProps.asideSecondaryDisplay && (
          <>
            <div className="aside-secondary d-flex flex-row-fluid">
              <div className="aside-workspace scroll scroll-push my-2">
                <div className="tab-content">
                  <AsideSearch isActive={activeTab === tabs.tabId1} />
                  <AsideMenu isActive={activeTab === tabs.tabId2} />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
